





















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  SearchIcon,
  TagIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import 'dayjs/locale/de';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import { ITag } from 'admiral-core';

@Component({
  name: 'tag-filter',
  components: {
    TagIcon,
    TagSelect,
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
  },
})
export default class TagFilterComponent extends mixins(FilterMixin) {
  @Prop({ type: Array, default: () => [] })
  selected!: ITag[];

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  @Prop({ type: Number, default: 1 })
  category!: number;

  updateTags(tags: ITag[]) {
    this.$emit('update', tags);
  }

  get isDefault() {
    return this.selected.length === 0;
  }

  reset() {
    this.$emit('update', []);
  }
}
